import { useEffect, useState } from 'react'
import { useCourseStore } from '../store/CourseStore'
import { useRoundStore } from '../store/RoundStore'
import ScoreButton from './ScoreButton'

const GolferRow = ({ golfer, round, updateScore, index }) => {
  const course = useCourseStore((state) => state.course)
  const holeNum = useRoundStore((state) => state.holeNum)

  const holeData = course?.courseHoles?.find((h) => h.holeNum === holeNum)

  // convert golfer to round
  let baseScore = round.holeScores[holeData.holeNum - 1]?.holeScore
  baseScore < 1 ? (baseScore = parseInt(holeData.holePar)) : (baseScore = 0)
  const rowColor = index % 2 === 0 ? '#ededed' : '#ffffff'

  return (
    <table width="100%" cellPadding="4" cellSpacing="0">
      <tbody>
        <tr key={golfer.golferId} style={{ backgroundColor: rowColor }}>
          <td style={{ width: '100%' }} className="golferScoreName">
            {golfer.golferName}
          </td>
          <td id="minusButtonContainer04" align="center" width="55px">
            <ScoreButton
              holeNum={holeData.holeNum}
              updateScore={updateScore}
              round={round}
              scoreChange={baseScore - 1}
              label={'-'}
            />
          </td>
          <td id="scoreDisplayContainer04" align="center" width="60px">
            <ScoreBox holeData={holeData} updateScore={updateScore} round={round} scoreChange={1} />
          </td>
          <td id="plusButtonContainer04" align="center" width="55px">
            <ScoreButton
              holeNum={holeData.holeNum}
              updateScore={updateScore}
              round={round}
              scoreChange={baseScore + 1}
              label={'+'}
            />
          </td>
        </tr>
      </tbody>
    </table>
  )
}

function ScoreBox({ round, holeData, updateScore }) {
  const score = round.holeScores[holeData.holeNum - 1]?.holeScore
  const [prevScore, setPrevScore] = useState(score)

  useEffect(() => {
    if (score !== prevScore) {
      const timeout = setTimeout(() => {
        setPrevScore(score)
      }, 250) // Animation duration (adjust as needed)
      return () => clearTimeout(timeout)
    }
  }, [score, prevScore])

  if (score > 0) {
    const isUnderPar = score < holeData.holePar
    return (
      <div
        className={`boldScore ${isUnderPar ? 'under-par' : ''}`}
      >
        {score}
      </div>
    )
  } else {
    return (
      <ScoreButton
        holeNum={holeData.holeNum}
        updateScore={updateScore}
        round={round}
        scoreChange={holeData.holePar}
        label={holeData.holePar}
      />
    )
  }
}

export default GolferRow
